if (!customElements.get("swiper-slider")) {
  class SwiperSlider extends HTMLElement {
    constructor() {
      super();

      var _this = this;
      this.isThumbnails = false;

      // swiper container
      this.swiperContainer = this.querySelector(".swiper-container");
      this.config = this.swiperContainer?.dataset || {};

      // Check thumbnails available or not
      if (this.config.thumbs) {
        this.isThumbnails = true;
      }

      // wait for swiper slider
      this.waitForSwiper(function () {
        // If thumbnails available
        _this.initSwiperWithThumbs(_this.swiperContainer);
      });
    }

    // Wait for swiper slider
    waitForSwiper(trigger) {
      var interval = setInterval(function () {
        if (typeof Swiper !== "undefined") {
          clearInterval(interval);
          trigger();
        }
      }, 50);
      setTimeout(function () {
        clearInterval(interval);
      }, 15000);
    }

    // Thumbnail configuration
    thumbConfig(thumbConfig) {
      var config = {
        slidesPerView: 3,
        spaceBetween: 12,
        loop: true,
        direction: "horizontal",
        a11y: false,
        watchSlidesProgress: true,
      };
      // Loop
      if (thumbConfig?.loop) {
        config.loop = thumbConfig.loop === "true";
      }
      // Slide per view
      if (thumbConfig?.slidesPerView > 1) {
        config.slidesPerView = parseInt(thumbConfig.slidesPerView);
      }

      // direction
      if (thumbConfig.direction) {
        config.direction = thumbConfig.direction;
      }

      // Breakpoints
      if (thumbConfig.breakpoints) {
        config.breakpoints = JSON.parse(thumbConfig.breakpoints);
      }

      return config;
    }

    // Gallery slider configuration
    galleryConfiguration(galleryConfig, thumbs) {
      var config = {
        slidesPerView: 1,
        spaceBetween: 12,
        loop: true,
        direction: "horizontal",
        thumbs: {},
        pagination: {
          el: "",
          clickable: true,
        },
        navigation: {
          nextEl: "",
          prevEl: "",
        },
        allowTouchMove: true,  // Enable or disable touch move
        a11y: false,           // Disable accessibility features
        watchSlidesProgress: true, // Enable slide progress tracking
      };

      // Slides per view
      if (galleryConfig?.slidesPerView) {
        config.slidesPerView = parseFloat(galleryConfig.slidesPerView);
      }

      // Space between
      if (galleryConfig?.spaceBetween) {
        config.spaceBetween = parseInt(galleryConfig.spaceBetween);
      }

      // Pagination
      if (galleryConfig.dots === "true") {
        config.pagination.el = galleryConfig.pagination;
      }

      // If prev/next element
      if (galleryConfig?.nav === "true") {
        config.navigation.prevEl = galleryConfig.prevEl;
        config.navigation.nextEl = galleryConfig.nextEl;
      }

      // direction
      if (galleryConfig.direction) {
        config.direction = galleryConfig.direction;
      }

      // Loop
      if(galleryConfig.loop) {
        config.loop = galleryConfig.loop === "true";
      }

      // if thumbs
      if (thumbs) {
        config.thumbs.swiper = thumbs;
      }

      //autoplay
      if (galleryConfig.autoplay === "true") {
        config.autoplay = {
          delay: parseInt(galleryConfig.autoplayDelay) || 4000,
          disableOnInteraction: false,
        };
      }

      // Breakpoints
      if (galleryConfig.breakpoints) {
        try {
          config.breakpoints = JSON.parse(galleryConfig.breakpoints);
        } catch (e) {
          console.error("Error parsing breakpoints:", e);
        }
      }

      return config;
    }

    // Initialize swiper slider with thumbs
    initSwiperWithThumbs() {
      // Thumbnails
      var sliderThumbs = document.querySelector(`${this.config["thumbsId"]}`);

      // Thumbnails initialize
      var thumbs;
      if (sliderThumbs) {
        var thumbConfig = sliderThumbs.dataset;
        thumbConfig = this.thumbConfig(thumbConfig);
        // Thumbnails
        thumbs = new Swiper(sliderThumbs, thumbConfig);
      }

      if (this.swiperContainer) {
        var galleryConfig = this.galleryConfiguration(this.config, thumbs);
        new Swiper(this.swiperContainer, galleryConfig);
      }
    }
  }

  customElements.define("swiper-slider", SwiperSlider);
}
